import React from 'react';
import SectionHeading from './ui/SectionHeading';

const showcaseImages = [
  { src: '/photos/p1.jpeg', alt: 'Eyeglass frames displayed on shelves at Vision World Albertson' },
  { src: '/photos/p2.jpeg', alt: 'Customer browsing optical frames in the showroom' },
  { src: '/photos/p3.jpeg', alt: 'Variety of designer sunglasses and eyeglasses' },
  { src: '/photos/p4.jpeg', alt: 'Close-up of eyewear collection at the Albertson store' },
];

function ImageShowcase() {
  return (
    <section className="bg-white py-16 md:py-24" aria-labelledby="showcase-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="showcase-heading"
          eyebrow="In the boutique"
          title="Product showcase"
          subtitle="A glimpse of the frames and styles waiting for you in store."
        />
        <ul className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {showcaseImages.map(({ src, alt }) => (
            <li
              key={src}
              className="group overflow-hidden rounded-2xl border border-slate-100 bg-slate-50 shadow-card transition-shadow duration-300 hover:shadow-card-hover"
            >
              <img
                src={src}
                alt={alt}
                className="aspect-square w-full object-cover transition duration-500 ease-out group-hover:scale-[1.03]"
                loading="lazy"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default ImageShowcase;
